import React, { useContext } from 'react';

import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import Link from 'next/link';
import { LocaleContext } from 'Components/hooks/context';

const atlas = new AtlasMetadataClient();

const CountryLink = ({ country: isoAlpha2 }) => {
  const locale = useContext(LocaleContext);
  const country = atlas.getCountry(isoAlpha2);
  return locale === 'en' ? (
    <Link href='/countries-and-territories/[country]' as={`/countries-and-territories/${country.slug}`}>
      <a>{country.translations[locale]}</a>
    </Link>
  ) : (
    <Link href='/[locale]/countries-and-territories/[country]' as={`/${locale}/countries-and-territories/${country.slug}`}>
      <a>{country.translations[locale]}</a>
    </Link>
  );
};

export default React.memo(CountryLink);
